import { PromiseClient, createPromiseClient } from "@connectrpc/connect";
import { createGrpcWebTransport } from "@connectrpc/connect-web";

import {
  DataDogCustomActionOptions,
  DataDogSetGlobalContext,
} from "datadog-loader/loader";

import { CheckoutFrontendV1Service } from "../generated-connect-es/checkout/fe/v1/checkout_fe_api_connect";
import {
  createVersionHeaderInterceptor,
  headerInterceptor,
} from "./header-interceptor";
import { errorHandlerSetup, logger } from "./logger-interceptor";

export const getFeClient = (
  baseUrl: string,
  target = "NA",
  version: string,
  ddSendCustomAction: ({ name, context }: DataDogCustomActionOptions) => void,
  ddSetGlobalContext: ({ name, context }: DataDogSetGlobalContext) => void
): PromiseClient<typeof CheckoutFrontendV1Service> => {
  // Default interceptors
  const interceptors = [
    headerInterceptor,
    createVersionHeaderInterceptor(version),
    errorHandlerSetup(ddSendCustomAction, ddSetGlobalContext),
  ];

  // If dev or local log req and res
  if (
    baseUrl.includes("local") ||
    baseUrl.includes("dev") ||
    target === "c7-local" ||
    target === "c7-dev"
  ) {
    interceptors.push(logger);
  }

  const transport = createGrpcWebTransport({
    baseUrl,
    interceptors,
  });

  return createPromiseClient<typeof CheckoutFrontendV1Service>(
    CheckoutFrontendV1Service,
    transport
  );
};
